import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Theme scope: entire site uses LIGHT (ferah/aydınlık) theme.
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const location = useLocation();
  const theme = "light";
  const isDark = false;
  const [current, setCurrent] = useState(theme);

  useEffect(() => {
    setCurrent(theme);
    try { localStorage.setItem("useko_theme", theme); } catch (e) { /* noop */ }
    document.documentElement.setAttribute("data-theme", theme);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", "#FBFAF6");
  }, [theme, location.pathname]);

  const noop = () => {};
  return (
    <ThemeContext.Provider value={{ theme: current, setTheme: noop, toggle: noop, isDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
